import { render, staticRenderFns } from "./ConfirmContractFulfillmentAttachmentRemovePopup.view.vue?vue&type=template&id=d68ff33e&"
import script from "./ConfirmContractFulfillmentAttachmentRemovePopup.view.vue?vue&type=script&lang=js&"
export * from "./ConfirmContractFulfillmentAttachmentRemovePopup.view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev2/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d68ff33e')) {
      api.createRecord('d68ff33e', component.options)
    } else {
      api.reload('d68ff33e', component.options)
    }
    module.hot.accept("./ConfirmContractFulfillmentAttachmentRemovePopup.view.vue?vue&type=template&id=d68ff33e&", function () {
      api.rerender('d68ff33e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/rearchitected/themes/atmo/views/overlays/popups/purchases/contract/attachments/fulfillment/ConfirmContractFulfillmentAttachmentRemovePopup.view.vue"
export default component.exports